export interface ParsedEmbedSnippet {
  containerHtml: string;
  scriptSrcs: string[];
  error: string | null;
}

export function parseEmbedSnippet(input: string): ParsedEmbedSnippet {
  const trimmed = input.trim();

  if (!trimmed) {
    return { containerHtml: '', scriptSrcs: [], error: null };
  }

  const scriptSrcs: string[] = [];
  const scriptTagRegex = /<script\b([^>]*)>/gi;
  let match;
  while ((match = scriptTagRegex.exec(trimmed)) !== null) {
    const srcMatch = match[1].match(/src=["']([^"']+)["']/i);
    if (srcMatch?.[1]) {
      const src = srcMatch[1].trim();
      if (src && !scriptSrcs.includes(src)) {
        scriptSrcs.push(src);
      }
    }
  }

  const containerHtml = trimmed.replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, '').trim();

  const hasHtmlTags = /<[a-z]/i.test(containerHtml);

  if (!hasHtmlTags && scriptSrcs.length === 0) {
    return {
      containerHtml: '',
      scriptSrcs: [],
      error: `Invalid embed snippet: ${trimmed}`,
    };
  }

  return { containerHtml, scriptSrcs, error: null };
}
